// Strings of the three-step product import (request of 29 Oct 2026, item 2). Arabic marked "new" needs review by an
// Arabic copy editor.
export const IMPORT_STRINGS: Record<"en" | "ar", Record<string, string>> = {
  en: {
    impSub3: "Upload a file, check every row and fix what is needed, then confirm. Nothing else is created: no categories, units, taxes, accounts, stock or balances.",
    impStep1: "Upload", impStep2: "Preview and fix", impStep3: "Confirm",
    impUploadHint: "Use the template in English or Arabic, or your own file with the same column headings. Excel (.xlsx) or CSV.",
    impReqTitle: "Each product needs:",
    impReqLists: "Category, item kind, tax and units are written by their name, as they are in Delta (English or Arabic). They must exist already, or you choose a default in the next step.",
    impReqText: "Codes and barcodes are text: leading zeros are kept. Several barcodes go in one cell, separated by |.",
    impReqSample: "The template's example rows (codes SAMPLE-…) are not imported: replace them with your products.",
    impTplXlsxEn: "Excel template (English)", impTplXlsxAr: "Excel template (Arabic)", impTplCsvEn: "CSV (English)", impTplCsvAr: "CSV (Arabic)",
    impChooseFile: "Choose a file", impChooseHint: ".xlsx or .csv, up to 5,000 rows",
    impOtherFile: "Choose another file",
    impMatched: "{n} of {m} columns matched by their heading",
    impAsks: "Before checking the rows:",
    impAskAmbiguous: "Two columns could be {f}. Which one is it?",
    impAskMissing: "No column was found for {f}. Which column has it?",
    impOrDefault: "or use for every row:",
    impDefaults: "Defaults", impDefaultsHint: "Used only in rows where the cell is empty. Choose from your own lists; nothing is created.",
    impDefaultFor: "Default {f}", impNoDefault: "No default",
    impExisting: "When a code already exists",
    impExistingRefuse: "Do not import the row (report it)",
    impExistingUpdate: "Update that product with the filled cells",
    impExistingHint: "Units, conversions and barcodes are never changed by an import. Every change is audited.",
    impExistingNoKey: "Updating products needs the Edit item permission.",
    impNames: "When a row has only one name",
    impNamesRefuse: "Do not import the row (report it)",
    impNamesCopy: "Use the name it has in both languages, as written",
    impNamesHint: "Delta never translates names.",
    impAdvanced: "Advanced options: every column",
    impPreviewRows: "Rows",
    impWillCreate: "To create", impWillUpdate: "To update",
    impOnlyProblems: "Show only rows with problems",
    impAction: "Action", impNamesCol: "Names", impRowWide: "Row",
    impAct_create: "Create", impAct_update: "Update", impAct_unchanged: "No change", impAct_error: "Not imported",
    impToConfirm: "Continue to confirm",
    impSumCreate: "products will be created", impSumUpdate: "existing products will be updated", impSumUnchanged: "rows match their product already", impSumSkip: "rows with problems will not be imported",
    impSumCopy: "Rows with one name take it in both languages, as written.", impSumNoCopy: "",
    impBack: "Back to the rows",
    impConfirm2: "Import: create {n}, update {m}",
    impUpdated: "Updated", impAnother: "Import another file",
    impRules3: "Only users with the Add item permission import, and Edit item to update, into their own business. An import is done once, even if the confirmation is sent twice.",
    impSampleName1: "Sample product (replace this row)", impSampleName2: "Sample product with a carton (replace this row)",
    impYes: "yes", impNo: "no",
    impE_sample_row: "Example row of the template",
    impE_update_unit_change: "Would change the product's units or conversion",
    impE_update_barcode_change: "Would change the product's barcodes",
    impFix_required: "Fill this cell.",
    impFix_required_default: "Fill this cell, or choose a default above.",
    impFix_not_found: "Write the name as it is in Delta, create it first, or choose a default for empty cells.",
    impFix_exists: "Choose 'Update that product' above to change it, or remove the row.",
    impFix_duplicate_in_file: "Keep one of the rows.",
    impFix_stored_as_number: "Format the column as text in Excel and type the value again.",
    impFix_sample_row: "Delete this row, or replace it with a product.",
    impFix_update_unit_change: "Units and conversions are changed on the product's page, not by import.",
    impFix_update_barcode_change: "Barcodes are changed on the product's page, not by import.",
    impFix_invalid: "Write the number like 1234.50, without separators.",
    impFix_yes_no: "Write yes or no.",
    impFix_barcode_scientific: "Format the column as text in Excel and type the barcode again."
  },
  ar: {
    impSub3: "ارفع الملف، راجع كل صف وصحّح ما يلزم، ثم أكّد. لا يُنشأ شيء آخر: لا تصنيفات ولا وحدات ولا ضرائب ولا حسابات ولا مخزون ولا أرصدة.", // new
    impStep1: "الرفع", impStep2: "المعاينة والتصحيح", impStep3: "التأكيد", // new
    impUploadHint: "استخدم القالب بالعربية أو الإنجليزية، أو ملفك بعناوين الأعمدة نفسها. Excel (.xlsx) أو CSV.", // new
    impReqTitle: "كل صنف يحتاج إلى:", // new
    impReqLists: "التصنيف ونوع الصنف والضريبة والوحدات تُكتب بأسمائها كما في دلتا (بالعربية أو الإنجليزية). يجب أن تكون موجودة، أو تختار قيمة افتراضية في الخطوة التالية.", // new
    impReqText: "الأكواد والباركودات نصوص: تبقى الأصفار البادئة. الباركودات المتعددة في خلية واحدة يفصلها |.", // new
    impReqSample: "صفوف المثال في القالب (أكواد SAMPLE-…) لا تُستورد: استبدلها بأصنافك.", // new
    impTplXlsxEn: "قالب Excel (إنجليزي)", impTplXlsxAr: "قالب Excel (عربي)", impTplCsvEn: "CSV (إنجليزي)", impTplCsvAr: "CSV (عربي)", // new
    impChooseFile: "اختر ملفًا", impChooseHint: "‎.xlsx أو ‎.csv، حتى 5,000 صف", // new
    impOtherFile: "اختر ملفًا آخر", // new
    impMatched: "تمت مطابقة {n} من {m} عمودًا بعناوينها", // new
    impAsks: "قبل مراجعة الصفوف:", // new
    impAskAmbiguous: "يوجد عمودان قد يكونان {f}. أيهما هو؟", // new
    impAskMissing: "لم يُعثر على عمود لـ{f}. أي عمود يحتويه؟", // new
    impOrDefault: "أو استخدم لكل الصفوف:", // new
    impDefaults: "القيم الافتراضية", impDefaultsHint: "تُستخدم فقط في الصفوف التي خليتها فارغة. اختر من قوائمك؛ لا يُنشأ شيء.", // new
    impDefaultFor: "{f} الافتراضي", impNoDefault: "بدون قيمة افتراضية", // new
    impExisting: "عندما يكون الكود موجودًا", // new
    impExistingRefuse: "لا تستورد الصف (أظهره كخطأ)", // new
    impExistingUpdate: "حدّث ذلك الصنف بالخلايا المعبأة", // new
    impExistingHint: "لا يغيّر الاستيراد الوحدات ولا معاملات التحويل ولا الباركودات أبدًا. كل تعديل يُسجَّل.", // new
    impExistingNoKey: "تحديث الأصناف يحتاج إلى صلاحية تعديل صنف.", // new
    impNames: "عندما يكون للصف اسم واحد", // new
    impNamesRefuse: "لا تستورد الصف (أظهره كخطأ)", // new
    impNamesCopy: "استخدم الاسم الموجود في اللغتين كما كُتب", // new
    impNamesHint: "لا يترجم دلتا الأسماء أبدًا.", // new
    impAdvanced: "خيارات متقدمة: كل الأعمدة", // new
    impPreviewRows: "الصفوف", // new
    impWillCreate: "للإنشاء", impWillUpdate: "للتحديث", // new
    impOnlyProblems: "اعرض الصفوف التي بها مشكلات فقط", // new
    impAction: "الإجراء", impNamesCol: "الأسماء", impRowWide: "الصف", // new
    impAct_create: "إنشاء", impAct_update: "تحديث", impAct_unchanged: "بلا تغيير", impAct_error: "لن يُستورد", // new
    impToConfirm: "متابعة إلى التأكيد", // new
    impSumCreate: "صنفًا سيُنشأ", impSumUpdate: "صنفًا موجودًا سيُحدَّث", impSumUnchanged: "صفًا مطابق لصنفه", impSumSkip: "صفًا به مشكلات لن يُستورد", // new
    impSumCopy: "الصفوف ذات الاسم الواحد تأخذه في اللغتين كما كُتب.", impSumNoCopy: "", // new
    impBack: "العودة إلى الصفوف", // new
    impConfirm2: "استيراد: إنشاء {n}، تحديث {m}", // new
    impUpdated: "المحدَّثة", impAnother: "استيراد ملف آخر", // new
    impRules3: "الاستيراد لمن لديه صلاحية إضافة صنف، والتحديث لمن لديه صلاحية تعديل صنف، وداخل منشأته. يتم الاستيراد مرة واحدة حتى لو أُرسل التأكيد مرتين.", // new
    impSampleName1: "صنف مثال (استبدل هذا الصف)", impSampleName2: "صنف مثال بكرتونة (استبدل هذا الصف)", // new
    impYes: "نعم", impNo: "لا", // new
    impE_sample_row: "صف مثال من القالب", // new
    impE_update_unit_change: "سيغيّر وحدات الصنف أو معامل التحويل", // new
    impE_update_barcode_change: "سيغيّر باركودات الصنف", // new
    impFix_required: "املأ هذه الخلية.", // new
    impFix_required_default: "املأ هذه الخلية أو اختر قيمة افتراضية أعلاه.", // new
    impFix_not_found: "اكتب الاسم كما في دلتا، أو أنشئه أولًا، أو اختر قيمة افتراضية للخلايا الفارغة.", // new
    impFix_exists: "اختر «حدّث ذلك الصنف» أعلاه لتعديله، أو احذف الصف.", // new
    impFix_duplicate_in_file: "أبقِ صفًا واحدًا منهما.", // new
    impFix_stored_as_number: "نسّق العمود كنص في Excel وأعد كتابة القيمة.", // new
    impFix_sample_row: "احذف هذا الصف أو استبدله بصنف.", // new
    impFix_update_unit_change: "تُعدَّل الوحدات ومعاملات التحويل من صفحة الصنف، لا بالاستيراد.", // new
    impFix_update_barcode_change: "تُعدَّل الباركودات من صفحة الصنف، لا بالاستيراد.", // new
    impFix_invalid: "اكتب الرقم مثل 1234.50 بلا فواصل.", // new
    impFix_yes_no: "اكتب نعم أو لا.", // new
    impFix_barcode_scientific: "نسّق العمود كنص في Excel وأعد كتابة الباركود." // new
  }
};
